/**
 * @file    useActiveEngineSlice.ts
 * @scope   ENTERPRISE
 * @summary Returns the in-memory slice (and dispatch) of the ACTIVE engine subtype.
 * @consumes EnterpriseContext, CprContext, active descriptor
 * @produces useActiveEngineSlice, ActiveEngineSlice
 * @sideEffects None.
 * @notes   Single place that knows which per-subtype provider backs which descriptor.
 *
 * TODO(ai): providers are already mounted generically (plugins/EngineProviders); move the slice
 * lookup into the plugin contract to drop this `id` switch.
 */
import { useEnterpriseContext } from 'components/DiyWidgetEngine/Subtypes/Enterprise/State/EnterpriseContext';
import { useCprContext } from 'components/DiyWidgetEngine/Subtypes/CrossProgramRollup/state/CprContext';
import { CPR_CHART_TYPE } from 'components/DiyWidgetEngine/Subtypes/CrossProgramRollup/constants';
import { ActiveEngineDescriptor } from './useActiveEngineDescriptor';

export type ActiveEngineSlice = {
  slice: unknown;
  dispatch: (action: any) => void;
};

export const isCprDescriptor = (descriptor: ActiveEngineDescriptor): boolean =>
  descriptor?.id === CPR_CHART_TYPE;

export const useActiveEngineSlice = (descriptor: ActiveEngineDescriptor): ActiveEngineSlice => {
  const enterprise = useEnterpriseContext();
  const cpr = useCprContext();
  return isCprDescriptor(descriptor)
    ? { slice: cpr.state, dispatch: cpr.dispatch }
    : { slice: enterprise.state, dispatch: enterprise.dispatch };
};

export default useActiveEngineSlice;
